import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const OrdersIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9253 2.95947H0.792969V5.3864H18.9253V2.95947Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1741 2.95944H2.54297L3.11986 1H16.5972L17.1741 2.95944Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6826 5.38623L16.5288 13.5224H13.8234C13.6543 13.5224 13.4852 13.5323 13.3162 13.5423C11.864 13.7114 10.6107 14.5369 9.8747 15.7106H9.86475C9.41716 16.4267 9.15856 17.2722 9.15856 18.1873H9.52657C8.95963 18.1873 8.43247 18.426 8.06445 18.8039C7.68649 19.172 7.45772 19.6892 7.45772 20.2661C7.45772 21.3999 8.38274 22.325 9.52657 22.325H9.15856C9.15856 23.6279 9.68572 24.8016 10.5411 25.6471H4.91144L2.04688 5.38623H17.6826Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7042 11.8715C13.7042 12.4782 13.5649 13.0452 13.3163 13.5425C11.8641 13.7116 10.6109 14.5371 9.87483 15.7108H9.86489C7.73635 15.7108 6.01562 13.9901 6.01562 11.8715C6.01562 9.75289 7.73635 8.02222 9.86489 8.02222C11.9934 8.02222 13.7042 9.74295 13.7042 11.8715Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5155 18.1876H9.1582C9.1582 17.2725 9.41681 16.4271 9.8644 15.7109H9.87434C10.6104 14.5372 11.8636 13.7117 13.3158 13.5426C13.4849 13.5327 13.654 13.5227 13.8231 13.5227H19.8406C21.1337 13.5227 22.2974 14.0399 23.1429 14.8854C23.9883 15.7308 24.5155 16.9045 24.5155 18.1876Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5055 22.3252C24.5055 23.6182 23.9883 24.782 23.1429 25.6373C22.2974 26.4728 21.1337 27 19.8406 27H13.8231C12.54 27 11.3862 26.4927 10.5408 25.6473C9.68536 24.8019 9.1582 23.6282 9.1582 22.3252H18.0503V23.5387C18.0503 24.3045 18.667 24.9113 19.4229 24.9113C20.1788 24.9113 20.7955 24.3045 20.7955 23.5387V22.3252H24.5055Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.206 20.2663C26.206 20.8332 25.9772 21.3505 25.5993 21.7185C25.2313 22.0964 24.7141 22.3252 24.1372 22.3252H20.7952V23.5387C20.7952 24.3045 20.1785 24.9113 19.4226 24.9113C18.6666 24.9113 18.05 24.3045 18.05 23.5387V22.3252H9.52588C8.38205 22.3252 7.45703 21.4002 7.45703 20.2663C7.45703 19.6894 7.6858 19.1722 8.06376 18.8042C8.43178 18.4262 8.95894 18.1875 9.52588 18.1875H11.3063L14.4195 21.3007L16.7171 19.0031L19.0148 21.3007L22.128 18.1875H24.1372C25.281 18.1875 26.206 19.1225 26.206 20.2663Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1276 18.1875L19.0144 21.3007L16.7168 19.0031L17.5324 18.1875H22.1276Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5331 18.1875L14.4199 21.3007L11.3066 18.1875H17.5331Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1276 18.1875L19.0144 21.3007L16.7168 19.0031L17.5324 18.1875H22.1276Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OrdersIcon;
